import React from "react"

const Footer = () => (
    <div id="footer">
        &copy; {new Date().getFullYear()} art specialists LC | all rights reserved | voice 301-320-8874 | fax 301-320-8274 | <a href="mailto:sfiegel@artspecialists.com">email</a>
    </div>
)

export default Footer